export default "__VITE_ASSET__Daw51t_R__"